var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.84H3V13.84H15V15.84ZM15 11.84H3V9.83997H15V11.84ZM15 7.83997H3V5.83997H15V7.83997ZM0 20.84L1.5 19.34L3 20.84L4.5 19.34L6 20.84L7.5 19.34L9 20.84L10.5 19.34L12 20.84L13.5 19.34L15 20.84L16.5 19.34L18 20.84V0.839966L16.5 2.33997L15 0.839966L13.5 2.33997L12 0.839966L10.5 2.33997L9 0.839966L7.5 2.33997L6 0.839966L4.5 2.33997L3 0.839966L1.5 2.33997L0 0.839966V20.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid9);
export default __webpack_public_path__ + "static/media/grid9.bc60abcb0a4391e08254c8671bb9f638.svg";
export { ForwardRef as ReactComponent };